export default "__VITE_ASSET__CTMSWTn2__"